<template>
    <div>
        <DxDropDownBox
            ref="dropDownBoxRefName"
            :drop-down-options="dropDownOptions"
            :data-source="geLineInfo"
            :value.sync="currentValue"
            content-template="contentTemplate"
            @value-changed="onValueChangedDropBox"
            :disabled="getEdit"
            display-expr="라인명"
            value-expr="라인코드"
        >
          <template #contentTemplate="{}">
            <dx-data-grid ref='refCompanyGrid'
              :data-source='geLineInfo'
              :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
              :selection="{ mode: 'single' }" :hover-state-enabled = "true" :allowColumnResizing = 'true'
              column-resizing-mode = 'widget' :allow-column-reordering = "true"
              :height='gridHeight'
              @selection-changed = "onSelectionChanged"
            >
              <DxSearchPanel
                :visible="true"
                placeholder="검색..."
              />
              <DxColumn
                :fixed="true"
                caption="라인코드"
                data-field="라인코드"
                width = '70'>
              </DxColumn>
              <DxColumn
                sort-order='asc'
                caption="라인명"
                data-field="라인명"
                width = '136'>
              </DxColumn>
              <dx-paging :enabled="false"/>
              <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
              <dx-sorting mode="multiple"/>
            </dx-data-grid>
          </template>
        </DxDropDownBox>
    </div>
</template>

<script>
import DxDataGrid, { DxScrolling,
  DxColumn, DxPaging, DxSorting, DxSearchPanel } from 'devextreme-vue/data-grid'

import DxDropDownBox from 'devextreme-vue/drop-down-box'
export default {
  name: 'lineGrid',
  data: function () {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 300 },
      dataSource: null,
      gridHeight: 300
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    lineInfo: {
      type: Array,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    onValueChanged: {
      type: Function,
      default: () => function (data) {
        // console.log(data)
      }
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxScrolling,
    DxDropDownBox
  },
  computed: {
    geLineInfo () {
      return this.lineInfo
    },
    getEdit () {
      return !this.isEdit
    }
  },
  created () {

  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onSelectionChanged (e) {
      console.log(e.selectedRowsData[0].라인코드)
      this.currentValue = e.selectedRowsData[0].라인코드
      this.onValueChanged(e.selectedRowsData[0].라인코드)
      this.$emit('selected-line', e.selectedRowsData[0].라인코드)
      this.$refs.dropDownBoxRefName.instance.close()
    },
    onValueChangedDropBox (e) {
      // console.log(e)
    }
  }
}
</script>

<style lang="scss">

</style>
